<script lang="ts"></script>

<script lang="ts" setup>
const { isMobile } = useDeviceType();

defineProps<{
  keyword: string;
}>();
</script>

<template>
  <div v-if="$slots.default" :class="$style.container">
    <h1 :class="[$style.container__title, $style.title]">
      {{ keyword }}に関する<br v-if="isMobile" />調査データ
    </h1>
    <p :class="[$style.container__lead, $style.lead]">
      オカネコ調べのデータをまとめました
    </p>
    <div :class="[$style.container__cardList, $style.cardList]">
      <slot />
    </div>
  </div>
</template>

<style lang="scss" module>
@use '../_constants.scss' as *;
.container {
  max-width: $content-width;
  padding: 0 16px;
}

.title {
  font-size: 36px;
  font-weight: bold;
  line-height: 50.4px;
  text-align: center;

  @include mobile-only {
    font-size: 24px;
    line-height: 33.6px;
  }
}

.lead {
  font-size: 16px;
  font-weight: bold;
  line-height: 28.8px;
  text-align: center;
  color: $color-text-and-object-accent-primary;
  @include mobile-only {
    line-height: 22.4px;
  }
}

.cardList {
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin-top: 40px;

  @include mobile-only {
    margin-top: 32px;
    gap: 16px;
  }
}
</style>
